<template>
    <div class="cellContainer">
        <!-- 排序 -->
        <div class="editable-cell"  v-if="cellType == 'xh'">
            <div v-if="editable" class="editable-cell-input-wrapper">
            <a-input :value="value" @change="handleChange" @pressEnter="check" /><a-icon
                type="check"
                class="editable-cell-icon-check"
                @click="check"
            />
            </div>
            <div v-else class="editable-cell-text-wrapper">
            {{ value || ' ' }}
            <a-icon type="edit" class="editable-cell-icon" @click="edit" />
            </div>
        </div>
        <!-- 查询排序 -->
        <div class="editable-cell"  v-if="cellType == 'order'">
            <div v-if="editable2" class="editable-cell-input-wrapper">
            <a-select :value="value2" @change="handleChange2" @pressEnter="check2" style="width:100%;">
                <a-select-option v-for="(item, index) in cxpxArr" :key="index" :value="item.key" :title="item.title">
                    {{ item.title }}
                </a-select-option>
            </a-select>
            <a-icon
                type="check"
                class="editable-cell-icon-check"
                @click="check2"
            />
            </div>
            <div v-else class="editable-cell-text-wrapper">
              {{ value2 == '1' ? '升序' : '降序'}}
              <a-icon type="edit" class="editable-cell-icon" @click="edit2" />
            </div>
        </div>
    </div>
</template>
     
     <script>

     export default {
       name: 'selectTcComponent',
       props:{
        text: String,
        cellType:String
       },
       data() {
         return {
            value: this.text,
            value2: this.text,
            editable: false,
            editable2: false,
            cxpxArr:[
                // { key: '0', title: "无" },
                { key: '1', title: "升序" },            
                { key: '2', title: "降序" }                   
            ],
         }
       },

       methods: {
        // 显示排序编辑方法
            handleChange(e) {
                const value = e.target.value;
                this.value = value;
            },
            check() {
                this.editable = false;
                this.$emit('change', this.value);
            },
            edit() {
                this.editable = true;
            },
            // 查询排序编辑方法
            handleChange2(e) {
                const value = e;
                this.value2 = value;
            },
            check2() {
                this.editable2 = false;
                this.$emit('change2', this.value2);
            },
            edit2() {
                this.editable2 = true;
            },
       }
     }
     </script>
     
     <style lang="less" scoped>
   .cellContainer{
    .editable-cell {
        position: relative;
        }

        .editable-cell-input-wrapper,
        .editable-cell-text-wrapper {
        padding-right: 24px;
        }

        .editable-cell-text-wrapper {
        padding: 5px 24px 5px 5px;
        }

        .editable-cell-icon,
        .editable-cell-icon-check {
        position: absolute;
        right: 0;
        width: 20px;
        cursor: pointer;
        color: rgba(255,255,255,0.5);
        }

        .editable-cell-icon {
        line-height: 32px;
        display: none;
        }

        .editable-cell-icon-check {
        line-height: 32px;
        }

        .editable-cell:hover .editable-cell-icon {
        display: inline-block;
        }

        .editable-cell-icon:hover,
        .editable-cell-icon-check:hover {
        color: rgba(255,255,255,0.5);
        }

        .editable-add-btn {
        margin-bottom: 8px;
        }
   }
     </style>
     